import {
  GetUrlRequest,
  GetStatusRequest,
  KycServiceClient,
} from '../proto/kycpb/verify_grpc_web_pb';
import { generateKey } from '../lib/generator/generator';
import { auth } from '../lib/auth/Auth';

const service = new KycServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });

export async function getUrl(param) {
  return new Promise((resolve, reject) => {
    let req = new GetUrlRequest();
    req.setUsrId(param.id);

    service.getVerifyUrl(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function getJumioStatus(param) {
  return new Promise((resolve, reject) => {
    let req = new GetStatusRequest();
    req.setTransactionReference(param.transactionReference);
    req.setAccountId(param.accountId);

    service.getStatus(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function mockJumioData(transactionReference) {
  if (transactionReference) {
    const status = await getJumioStatus({
      transactionReference: transactionReference,
    });
    return new Promise((resolve) => {
      setTimeout(async function () {
        resolve({
          data: {},
          status: status,
        });
      }, 1500);
    });
  }
  return new Promise((resolve) => {
    setTimeout(async function () {
      resolve({
        data: {},
        status: {
          result: 'APPROVED_VERIFIED',
          idType: 'PASSPORT',
          idCountry: 'PHL',
          idImg: 'data:image/png;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs=',
          screeningStatus: 'DONE',
          screenResult: 0,
          identificationNo: generateKey(9),
          idDob: {
            month: 12,
            day: 12,
            year: 1989,
          },
          issueDate: {
            month: 11,
            day: 11,
            year: 2023,
          },
          expiry: {
            month: 1,
            day: 1,
            year: 2755,
          },
          state: 'MOCK',
        },
      });
    }, 1500);
  });
}
